<template>
    <div>
        <a-tabs v-model="tabNumber" defaultActiveKey="1" class="air-tabs-bordered">
              <a-tab-pane tab="Import" key="1" v-if="$auth.check('admin')" />
              <a-tab-pane tab="Verwerken" key="2" v-if="$auth.check('admin')" />
              <a-tab-pane tab="Handmatig Koppelen" key="3" v-if="$auth.check('admin')" />
        </a-tabs>
        <div v-if="tabNumber == '1'">
            <camt-import-component />
        </div>
        <div v-if="tabNumber == '2'">
            <camt-process-component />
        </div>
        <div v-if="tabNumber == '3'">
            <camt-potential-matches-component />
        </div>
    </div>
</template>
<script>
import CamtImportComponent from '@/components/widgets/Bookkeeping/Camt/CamtImportComponent.vue'
import CamtProcessComponent from '@/components/widgets/Bookkeeping/Camt/CamtProcessComponent.vue'
import CamtPotentialMatchesComponent from '@/components/widgets/Bookkeeping/Camt/CamtPotentialMatchesComponent.vue'
// import moment from 'moment'
export default {
  data() {
    return {
      tabNumber: '1',
    }
  },
  components: {
    CamtImportComponent,
    CamtProcessComponent,
    CamtPotentialMatchesComponent,
  },
}
</script>
